import { useQuerystring } from "$routes/_lib/use-querystring";
import { useNavigate } from "react-router-dom";

export function useUpdateQueryParamCallback({
  linkFactory,
}: {
  linkFactory: (queryParams: Record<string, string | Date>) => string;
  analyticsNamespace: string;
}) {
  const queryParams = useQuerystring();
  const navigate = useNavigate();

  return (varName: string) => (value: string | Date) => {
    navigate(linkFactory({ ...queryParams, [varName]: value }));
  };
}
